import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap'
import { Table } from 'rsuite';
import recentUpdateService from '../../../services/Shared/recentUpdate.service';
import GenericBadge from '../../Shared/Badge/GenericBadge';
import GenericPagination from '../../Shared/Grid/GenericPagination';

function RecentUpdatesV2() {
    const [displayLength, setDisplayLength] = useState(50);
    const [gridLoading, setGridLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [gridData, setGridData] = useState([]);
    useEffect(() => {
        setGridLoading(true);
        recentUpdateService.getRecentUpdate().then((response) => {
            setGridData(response.data);
            setGridLoading(false);
        });
    }, [])
    const goToPage = (data) => {
        if (data.issueId) {
            window.open("internal/redirectToSection?issueId=" + data.issueId, "_self");
        }
    }
    const getData = () => {
        return gridData.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        })
    }
    let filteredData = getData();
    return (
        <Card>
            <Card.Body>
                <div style={{ textAlign: 'center' }}><h5>Recent Updates <i>(click to review)</i></h5></div>
                <GenericPagination page={page} dataLength={gridData.length} displayLength={displayLength} setDisplayLength={setDisplayLength} setPage={setPage} discludeAllLength={false} removePadding={true} />
                <div id="recentUpdatesInfiniteDiv">
                    <Table
                        autoHeight
                        wordWrap
                        showHeader={false}
                        loading={gridLoading}
                        data={filteredData} >
                        <Table.Column flexGrow={1}>
                            <Table.HeaderCell />
                            <Table.Cell dataKey="issueId">
                                {data => {
                                    return (<div onClick={() => { goToPage(data) }} className="recentUpdateItem">
                                        <Row>
                                            <Col className="text-left text-muted"><h5>{data.name}</h5></Col>
                                            <Col className="text-right text-small">{new Date(data.date).toLocaleDateString()}</Col>
                                        </Row>
                                        <Row><Col>Message in &nbsp; <GenericBadge status={data.updateOwner} /></Col></Row>
                                        <Row className="mb-2"><Col>{data.text}</Col>
                                            {data.isClosed && <Col sm="3" className="text-right text-small text-danger"><b>CLOSED</b></Col>}
                                            {!data.isClosed && <Col sm="3" className="text-right text-small text-success"><b>OPEN</b></Col>}
                                        </Row>
                                    </div>
                                    );
                                }}
                            </Table.Cell>
                        </Table.Column>
                    </Table >
                    <GenericPagination page={page} dataLength={gridData.length} displayLength={displayLength} setDisplayLength={setDisplayLength} setPage={setPage} discludeAllLength={false} />
                </div>
            </Card.Body>
        </Card>
    )
}

export default RecentUpdatesV2;